import { useEffect, useId, useRef, useState } from "react";
import { Button } from "./Button";
import { LabeledField } from "./LabeledField";
import { Row } from "./Stack";

/** Texto de sólo lectura con botón Copiar (links de invitación, CBU…). */
export function CopyField({ etiqueta, valor }: { etiqueta: string; valor: string }) {
  const id = useId();
  const input = useRef<HTMLInputElement>(null);
  const [copiado, setCopiado] = useState(false);

  useEffect(() => {
    if (!copiado) return;
    const t = setTimeout(() => setCopiado(false), 2000);
    return () => clearTimeout(t);
  }, [copiado]);

  const copiar = async () => {
    try {
      await navigator.clipboard.writeText(valor);
      setCopiado(true);
    } catch {
      input.current?.select(); // sin permiso de portapapeles: queda seleccionado para copiar a mano
    }
  };

  return (
    <LabeledField etiqueta={etiqueta} htmlFor={id}>
      <div>
        <Row espacio={2}>
          <input
            ref={input}
            id={id}
            readOnly
            value={valor}
            onFocus={(e) => e.currentTarget.select()}
            className="h-11 min-w-0 flex-1 rounded-control border border-borde-fuerte bg-superficie-2 px-3 text-chico"
          />
          <Button variante="secundario" onClick={() => void copiar()}>
            {copiado ? "Copiado" : "Copiar"}
          </Button>
        </Row>
        <span aria-live="polite" className="sr-only">
          {copiado ? "Copiado al portapapeles" : ""}
        </span>
      </div>
    </LabeledField>
  );
}
